<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Job Title"
              aria-label="Job Title"
              aria-describedby="Job Title"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getJobApplications(1)">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="jobApplications">
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Job Title</th>
          <th class="text-center">Applicant</th>
          <th class="text-center">Company</th>
          <th class="text-center">Last Update</th>
          <th class="text-center">Status</th>
          <th></th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.job_title}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.applicant}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.company}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.last_update}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.status}}</span>
              </div>
            </div>
          </td>

          <td class="text-right">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" @click="getJobApplication(row.job_id)">View</a>
                <a class="dropdown-item" @click="getJobApplicant(row.user_id)">View Applicant</a>
                <a class="dropdown-item" @click="getJobCompany(row.company_id)">View Company</a>
              </template>
            </base-dropdown>
          </td>

        </template>

      </base-table>
    </div>

    <div class="row" id="div-edit-admin-profile">
        <div class="col-md-4">
            <modal :show.sync="modals.job_application_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">JOB APPLICATION</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div>
                                  <tabs fill class="flex-column flex-md-row">
                                      <card shadow>
                                          <tab-pane title="Job Detail">
                                              <span slot="title">
                                                  Job Detail
                                              </span>

                                              <div class="row">
                                                <div class="col-sm-3">Job Title: </div>
                                                <div class="col-sm-9">{{jobApplication.jobTitle}}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Position Level: </div>
                                                <div class="col-sm-9">{{jobApplication.positionLevel}}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Job Specialization: </div>
                                                <div class="col-sm-9">{{jobApplication.jobSpecialization}}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Salary: </div>
                                                <div class="col-sm-9">{{jobApplication.salary}}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Working Location: </div>
                                                <div class="col-sm-9">{{jobApplication.workingLocation}}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Why Join Us: </div>
                                                <div class="col-sm-9">{{jobApplication.whyJoinUs}}</div>
                                              </div>
                                          </tab-pane>
                                      </card>
                                  </tabs>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.job_application_modal = false">Cancel</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-edit-admin-profile2">
        <div class="col-md-4">
            <modal :show.sync="modals.job_applicant_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">CANDIDATE PROFILE</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="row">
                                  <div class="media align-items-center" slot="title">
                                    <span class="avatar avatar-lg rounded-circle">
                                      <img alt="Image placeholder" class="custom-height" v-bind:src="candidate_profile.profile_picture">
                                    </span>
                                  </div>
                                  <div class="media-body ml-2 d-none d-lg-block col-lg-12">
                                      <span>Full Name: {{ candidate_profile.full_name }}</span><br />
                                      <span>Current Position (years): {{ candidate_profile.current_position_years }}</span><br />
                                      <span>Current Company Name: {{ candidate_profile.current_company_name }}</span>
                                  </div>
                                </div>
                                <hr class="my-4" />
                                <div>
                                  <tabs fill class="flex-column flex-md-row">
                                      <card shadow>
                                          <tab-pane title="Info">
                                              <span slot="title">
                                                  Info
                                              </span>

                                              <div class="row">
                                                <div class="col-sm-3">Nationality: </div>
                                                <div class="col-sm-9">{{ candidate_profile.nationality }}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Gender: </div>
                                                <div class="col-sm-9">{{ candidate_profile.gender }}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Contact No.: </div>
                                                <div class="col-sm-9">{{ candidate_profile.contact_number }}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Email Address: </div>
                                                <div class="col-sm-9">{{ candidate_profile.email_address }}</div>
                                              </div>
                                              <div class="row">
                                                <div class="col-sm-3">Address: </div>
                                                <div class="col-sm-9">{{ candidate_profile.address }}</div>
                                              </div>

                                              <hr class="my-4" />

                                              <span style="font-weight: bold;">Education</span><br /><br />

                                              <div v-for="(item, index) in candidate_profile.education">
                                                <div class="row">
                                                  <div class="col-sm-6">{{ item.date }}</div>
                                                  <div class="col-sm-6">{{ item.institute }}<br />{{ item.qualification }}<br />{{ item.major }}</div>
                                                </div>

                                                <hr class="my-4" />
                                              </div>

                                              <span style="font-weight: bold;">Experience</span><br /><br />

                                              <div v-for="(item, index) in candidate_profile.experience">
                                                <div class="row">
                                                  <div class="col-sm-6">{{ item.date }}</div>
                                                  <div class="col-sm-6">{{ item.job_title }} ({{ item.company }})</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Position Level: </div>
                                                  <div class="col-sm-6">{{ item.position_level.value }}</div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-sm-6">Experience Description: </div>
                                                  <div class="col-sm-6">{{ item.working_description }}</div>
                                                </div>

                                                <hr class="my-4" />
                                              </div>

                                              <span style="font-weight: bold;">Skills</span><br /><br />

                                              <div class="row">
                                                <div class="col-sm-3">Skills: </div>
                                                <div class="col-sm-9">{{ candidate_profile.skills }}</div>
                                              </div>


                                          </tab-pane>

                                          <tab-pane title="Additional">
                                               <span slot="title">
                                                  Additional
                                                </span>

                                                <div class="row">
                                                  <div class="col-sm-3">Resume: </div>
                                                  <div class="col-sm-9" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;" v-if="candidate_profile.resume != ''"><a :href="candidate_profile.resume" rel="noopener noreferrer" target="_blank">{{ candidate_profile.resume }}</a></div>
                                                  <div class="col-sm-9" v-else>-</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-sm-3">Expected Salary: </div>
                                                  <div class="col-sm-9">{{ candidate_profile.currency }} {{ candidate_profile.expected_salary }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-sm-3">Languages: </div>
                                                  <div class="col-sm-9">
                                                    <li v-for="language in candidate_profile.languages" :key="language.id">
                                                      {{ language.language.value }}: Speak({{ language.spoken_rating }}), Write({{ language.written_rating }})
                                                    </li>
                                                  </div>
                                                </div>
                                          </tab-pane>
                                      </card>
                                  </tabs>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.job_applicant_modal = false">Cancel</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-edit-employers-profile">
        <div class="col-md-4">
            <modal :show.sync="modals.job_company_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg" id="modal-edit-employers-profile">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">JOB APPLICATION</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div>
                                  <tabs fill class="flex-column flex-md-row">
                                      <card shadow>
                                          <tab-pane title="Info">
                                              <span slot="title">
                                                  Info
                                              </span>

                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Company Name: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Company Name"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.companyName"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Reg. No.: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Reg. No."
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.companyReg"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Industry: </div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.industry" :disabled="true">
                                                     <option value=''>-- Select Industry --</option>
                                                     <template v-for="(data, key) in industriesList">
                                                        <option v-bind:key="key" v-bind:value="data.industry_id">{{ data.name }}</option>
                                                    </template>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Person In Charge: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Person In Charge"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.pic"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Contact No.: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Contact No."
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.contactNo"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Website: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Website"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.website"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3">Is Anonymous: </div>
                                                <div class="col-sm-9">
                                                  <base-checkbox class="mb-3" v-model="employer.isAnonymous" :disabled="true"></base-checkbox>
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Additional">
                                              <span slot="title">
                                                  Additional
                                              </span>
                                              
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Dress Code: </div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.dressCode" :disabled="true">
                                                     <option value=''>-- Select Dress Code --</option>
                                                     <template v-for="(data, key) in dressCodesList">
                                                        <option v-bind:key="key" v-bind:value="data.dress_code_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Company Size: </div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.companySize" :disabled="true">
                                                     <option value=''>-- Select Company Size --</option>
                                                     <template v-for="(data, key) in companySizesList">
                                                        <option v-bind:key="key" v-bind:value="data.company_size_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Working Hours: </div>
                                                <div class="col-sm-4">
                                                    <base-input addon-left-icon="ni ni-time-alarm" :disabled="true">
                                                        <flat-picker slot-scope="{focus, blur}"
                                                                     @on-open="focus"
                                                                     @on-close="blur"
                                                                     :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                                                                     class="form-control datepicker text-padding"
                                                                     v-model="employer.workingHoursStart"
                                                                     >
                                                        </flat-picker>
                                                    </base-input>                                    
                                                </div>
                                                <div class="col-sm-1 col-form-label">
                                                  -
                                                </div>
                                                <div class="col-sm-4">
                                                  <base-input addon-left-icon="ni ni-time-alarm" :disabled="true">
                                                      <flat-picker slot-scope="{focus, blur}"
                                                                   @on-open="focus"
                                                                   @on-close="blur"
                                                                   :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                                                                   class="form-control datepicker text-padding"
                                                                   v-model="employer.workingHoursEnd"
                                                                   >
                                                      </flat-picker>
                                                  </base-input>  
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Spoken Language: </div>
                                                <div class="col-sm-9">
                                                  <base-input>
                                                   <select class="form-control" v-model="employer.spokenLanguage" :disabled="true">
                                                     <option value=''>-- Select Spoken Language --</option>
                                                     <template v-for="(data, key) in spokenLanguagesList">
                                                        <option v-bind:key="key" v-bind:value="data.language_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                 </base-input>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Overview: </div>
                                                <div class="col-sm-9">
                                                  <textarea class="form-control" rows="3" placeholder="Overview" v-model="employer.overview" :disabled="true"></textarea>
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Address">
                                              <span slot="title">
                                                  Address
                                              </span>

                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Line 1: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Line 1"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.line1"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Line 2: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Line 2"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.line2"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Town: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Town"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.town"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Postal Code: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Postal Code"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.postalCode"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Country: </div>
                                                <div class="col-sm-9">
                                                   <select class="form-control" v-model="employer.country" v-on:change="getStates()" :disabled="true">
                                                     <option value=''>-- Select Country --</option>
                                                     <template v-for="(data, key) in countries">
                                                        <option v-bind:key="key" v-bind:value="data.country_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                 </base-input>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">State: </div>
                                                <div class="col-sm-9">
                                                    <base-input alternative=""
                                                              placeholder="State"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.state"
                                                              :disabled="true"
                                                    />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Latitude: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Latitude"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.latitude"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Longitude: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Longitude"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.longitude"
                                                              :disabled="true"
                                                  />
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Photos">
                                              <div class="row">
                                                <div class="col-sm-3">Photos: </div>
                                                <div class="col-sm-9">
                                                  <!-- <div class="input-group"> -->
                                                    <div class="custom-file-container" data-upload-id="myUniqueUploadId">
                                                        <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                        <label class="custom-file-container__custom-file">
                                                            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" multiple aria-label="Choose File">
                                                            <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                            <span class="custom-file-container__custom-file__custom-file-control" onclick='return false;'></span>
                                                        </label>
                                                        <div class="custom-file-container__image-preview"></div>
                                                    </div>
                                                  </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Banner">
                                             <div class="row">
                                              <div class="col-sm-3">Banner: </div>
                                              <div class="col-sm-9">
                                                <div class="custom-file-container" data-upload-id="bannerUpload">
                                                    <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                    <label class="custom-file-container__custom-file" >
                                                        <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" aria-label="Choose File">
                                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                        <span class="custom-file-container__custom-file__custom-file-control" onclick='return false;'></span>
                                                    </label>
                                                    <div class="custom-file-container__image-preview"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </tab-pane>

                                          <tab-pane title="Logo">
                                            <div class="row">
                                              <div class="col-sm-3">Logo: </div>
                                              <div class="col-sm-9">
                                                <div class="custom-file-container" data-upload-id="logoUpload">
                                                    <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                    <label class="custom-file-container__custom-file" >
                                                        <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" aria-label="Choose File">
                                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                        <span class="custom-file-container__custom-file__custom-file-control" onclick='return false;'></span>
                                                    </label>
                                                    <div class="custom-file-container__image-preview"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </tab-pane>
                                      </card>
                                  </tabs>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.job_company_modal = false">Cancel</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :perPage="10" :total="totalJobApplications" :value="pageNumber"></base-pagination>
    </div>

  </div>
</template>
<script>
  import FileUploadWithPreview from 'file-upload-with-preview';
  import 'file-upload-with-preview/dist/file-upload-with-preview.min.css';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    name: 'job-applications-table',
    props: {
      type: {
        type: String
      },
      title: String,
      status: String
    },
    components: {
      flatPicker
    },
    data() {
      return {
        search_text: "",
        totalJobApplication: 0,
        modals: {
          job_application_modal: false,
          job_company_modal: false,
          job_applicant_modal: false
        },
        jobApplication: {
          jobTitle: '',
          positionLevel: '',
          jobSpecialization: '',
          employmentType: '',
          salary: '',
          workingLocation: '',
          whyJoinUs: ''
        },
        candidate_profile: {
          full_name: '',
          current_position_years: '',
          current_company_name: '',
          nationality: '',
          gender: '',
          contact_number: '',
          email_address: '',
          address: '',
          education: [],
          experience: [],
          skills: '',
          resume: '',
          expected_salary: '',
          languages: [],
          profile_picture: '',
          currency: ''
        },
        employer: {
          companyName: '',
          companyReg: '',
          industry: '',
          pic: '',
          contactNo: '',
          website: '',
          isAnonymous: false,
          dressCode: '',
          companySize: '',
          workingHoursStart: '',
          workingHoursEnd: '',
          spokenLanguage: '',
          overview: '',
          line1: '',
          line2: '',
          town: '',
          postalCode: '',
          state: '',
          country: '',
          latitude: 0.000000,
          longitude: 0.000000,
          loginEmail: '',
          currentPassword: '',
          password: '',
          confirmedPassword: '',
          photo: [],
          original_photo: [],
          banner: '',
          logo: ''
        },
        uploadedPhotos: ''
      }
    },
    computed: {
      jobApplications()
      {
        return this.$store.getters.jobApplications;
      },
      pageNumber()
      {
        return parseInt(this.$route.query.page);
      },
      totalJobApplications()
      {
        return this.totalJobApplication;
      },
      countries()
      {
        return this.$store.getters.countries;
      },
      states()
      {
        return this.$store.getters.states;
      },
      dressCodesList()
      {
        return this.$store.getters.dressCodesList;
      },
      industriesList()
      {
        return this.$store.getters.industriesList;
      },
      companySizesList()
      {
        return this.$store.getters.companySizesList;
      },
      spokenLanguagesList()
      {
        return this.$store.getters.spokenLanguagesList;
      }
    },
    watch: {
      pageNumber() {
        this.getJobApplications(this.$route.query.page);
      },
      status: function() {
        this.getJobApplications(this.$route.query.page);
        this.getTotalJobApplication();
      }
    },
    mounted() {
      this.getJobApplications(1);
      this.getTotalJobApplication();
      this.getCountries();
      this.getDressCodes();
      this.getIndustries();
      this.getCompanySizes();
      this.getSpokenLanguages();
      this.uploadedPhotos = new FileUploadWithPreview('myUniqueUploadId');
    },
    methods: {
      getJobApplication(job_id)
      {
        this.modals.job_application_modal = true;
        this.$store.dispatch('fetchJobApplication', {
          job_id: job_id
        }).then (response => {
          this.jobApplication.jobTitle = response.data.job_title;
          this.jobApplication.positionLevel = response.data.position_level;
          this.jobApplication.jobSpecialization = response.data.specialisation;
          this.jobApplication.employmentType = response.data.job_type;
          this.jobApplication.salary = response.data.salary;
          this.jobApplication.workingLocation = response.data.location;
          this.jobApplication.whyJoinUs = response.data.why_join_us;
        });
      },

      getJobApplicant(user_id)
      {
        this.modals.job_applicant_modal = true;
        this.$store.dispatch('fetchEmployee', {
          candidate_profile_id: user_id
        }).then(response => {
          this.candidate_profile.full_name = response.data.full_name;
          this.candidate_profile.current_position_years = response.data.current_position_years == null || response.data.current_position_years == '-'  ? '-' : parseFloat(response.data.current_position_years).toFixed(1);
          this.candidate_profile.current_company_name = response.data.current_company_name == '' ? '-' : response.data.current_company_name;
          this.candidate_profile.nationality = response.data.nationality;
          this.candidate_profile.gender = response.data.gender;
          this.candidate_profile.contact_number = response.data.contact_number;
          this.candidate_profile.email_address = response.data.email_address;
          this.candidate_profile.address = response.data.address;
          this.candidate_profile.education = response.data.education;
          this.candidate_profile.experience = response.data.experience;
          this.candidate_profile.skills = response.data.skills;
          this.candidate_profile.expected_salary = response.data.expected_salary;
          this.candidate_profile.profile_picture = response.data.profile_picture == '' ? 'img/theme/team-4-800x800.jpg' : response.data.profile_picture;
          this.candidate_profile.currency = response.data.currency;
          this.candidate_profile.resume = response.data.resume;
          this.candidate_profile.languages = response.data.languages;
        });
      },

      getJobCompany(company_id)
      {
        
        // this.$store.dispatch('fetchEmployer', {
        //   id: parseInt(company_id)
        // }).then (response => {
        //   let responseData = response.data;
        //   this.employer.companyName = responseData.company_name;
        //   this.employer.companyReg = responseData.registration_number;
        //   this.employer.industry = responseData.industry;
        //   this.employer.pic = responseData.pic;
        //   this.employer.contactNo = responseData.contact_number;
        //   // this.employer.emailAddress = responseData.email_address;
        //   this.employer.website = responseData.website;
        //   this.employer.isAnonymous = responseData.is_anonymous == 1 ? true : false;
        //   this.employer.dressCode = responseData.dress_code;
        //   this.employer.companySize = responseData.company_size;
        //   this.employer.workingHoursStart = responseData.working_hours.split('-')[0];
        //   this.employer.workingHoursEnd = responseData.working_hours.split('-')[1];
        //   this.employer.spokenLanguage = responseData.spoken_language;
        //   this.employer.overview = responseData.overview;
        //   this.employer.line1 = responseData.line_1;
        //   this.employer.line2 = responseData.line_2;
        //   this.employer.town = responseData.city;
        //   this.employer.postalCode = responseData.postcode;
        //   this.employer.state = responseData.state;
        //   this.employer.country = responseData.country;
        //   this.employer.latitude = responseData.latitude;
        //   this.employer.longitude = responseData.longitude;
        //   this.employer.loginEmail = responseData.email_address;
        //   this.employer.logo = responseData.logo;
        // });

        this.modals.job_company_modal = true;
        this.employer.photo = [];
        this.action = 2;

        this.$store.dispatch('fetchEmployer', {
           id: company_id
        }).then (response => {
          let responseData = response.data;

          this.employer.companyName = responseData.company_name;
          this.employer.companyReg = responseData.registration_number;
          this.employer.website = responseData.website;
          this.employer.workingHoursStart = responseData.working_hours.split('-')[0];
          this.employer.workingHoursEnd = responseData.working_hours.split('-')[1];
          this.employer.companySize = responseData.company_size;
          this.employer.industry = responseData.industry;
          this.employer.dressCode = responseData.dress_code;
          this.employer.spokenLanguage = responseData.spoken_language;
          this.employer.logo = responseData.logo_original;
          this.employer.banner = responseData.banner_original;
          this.employer.overview = responseData.overview;
          this.employer.isAnonymous = responseData.is_anonymous == 1 ? true : false;
          this.employer.pic = responseData.pic;
          this.employer.contactNo = responseData.contact_number;
          this.employer.line1 = responseData.line_1;
          this.employer.line2 = responseData.line_2;
          this.employer.town = responseData.city;
          this.employer.postalCode = responseData.postcode;
          this.employer.state = responseData.state;
          this.employer.country = responseData.country;
          this.employer.latitude = responseData.latitude;
          this.employer.longitude = responseData.longitude;
          this.employer.photo = responseData.gallery;
          this.employer.original_photo = responseData.gallery_original;

          this.employer.loginEmail = responseData.email_address;

          
          this.uploadedPhotos.clearPreviewPanel();

          if (responseData.gallery.length === 0) {
            // var upload = new FileUploadWithPreview('myUniqueUploadId');
          } else {
            this.uploadedPhotos.addImagesFromPath(responseData.gallery);
            // console.log(this.uploadedPhotos.cachedFileArray);
          }

          if (responseData.banner != '') {
            var bannerUpload = new FileUploadWithPreview('bannerUpload', {
              presetFiles: [
                responseData.banner
              ]
            });
          } else {
            var bannerUpload = new FileUploadWithPreview('bannerUpload');
          }

          if (responseData.logo != '') {
            var logoUpload = new FileUploadWithPreview('logoUpload', {
              presetFiles: [
                responseData.logo
              ]
            });
          } else {
            var logoUpload = new FileUploadWithPreview('logoUpload');
          }
        });
      },

      getJobApplications : function (page_number) {
        this.$store.dispatch('fetchJobApplications', { keyword: this.search_text, page:page_number, status: this.status }).then (response => {
          const { data, meta } = response.data;
          this.totalJobApplication = meta.total_result;
          this.$router.push({ query: { page: page_number } });
          this.$store.dispatch('updateState', {
              key : 'jobApplications',
              value : data
          });
        });
      },

      getTotalJobApplication()
      {
          this.$store
            .dispatch("fetchTotalJobApplicationByStatus", {
              status: this.status
            })
            .then((response) => {
              let responseData = response.data;
              this.totalJobApplication = responseData;
            })
            .catch((e) => {
              console.log(e)
            })
      },

      getCountries()
      {
        this.$store.dispatch('fetchCountries').then (response => {
          this.$store.dispatch('updateState', {
              key : 'countries',
              value : response.data
          });
        });
      },

      getStates : function () {
        this.$store.dispatch('fetchStates', {
          country_id : this.employer.country
        }).then (response => {
          this.$store.dispatch('updateState', {
              key : 'states',
              value : response.data
          });
        });
      },

      getDressCodes : function () {
        this.$store.dispatch('fetchDressCodesList').then (response => {
          this.$store.dispatch('updateState', {
              key : 'dressCodesList',
              value : response.data
          });
        });
      },

      getIndustries : function () {
        this.$store.dispatch('fetchIndustriesList').then (response => {
          this.$store.dispatch('updateState', {
              key : 'industriesList',
              value : response.data
          });
        });
      },

      getCompanySizes : function () {
        this.$store.dispatch('fetchCompanySizesList').then (response => {
          this.$store.dispatch('updateState', {
            key : 'companySizesList',
            value : response.data
          });
        });
      },

      getSpokenLanguages : function () {
        this.$store.dispatch('fetchSpokenLanguagesList').then (response => {
          this.$store.dispatch('updateState', {
            key : 'spokenLanguagesList',
            value : response.data
          });
        });
      }
    }
  }
</script>
<style>
.custom-height {
  height: 100%;
}

.col {
  margin-bottom: 15px;
}

.text-padding {
  padding-left: 10px !important;
}

.custom-file-container__custom-file__custom-file-control {
  color: #8898aa;
  border-color: #cad1d7;
}

.custom-file-container__custom-file__custom-file-control__button {
  color: #8898aa;
}
</style>
